import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import CommonSourceAccount from "../../../../_utils/TransactionCommonComponents/CommonSourceAccount";
import TransactionOccurrenceDetails from "../../../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";

const ScheduleTransactionStepConfirm = ({
  txnPayLoad,
  setTxnPayLoad,
  isConfidential,
  previewImages,
  allLabels,
  uploadedFiles,
}) => {
  const formateDate = (date) => {
    const dates = new Date(date || new Date());

    const day = dates.toLocaleDateString("en-GB", { day: "2-digit" });
    const month = dates.toLocaleDateString("en-GB", { month: "short" });
    const year = dates.toLocaleDateString("en-GB", { year: "numeric" });

    return `${day} ${month}, ${year}`;
  };

  return (
    <>
      <div className="w-width-full Qlg:px-padding-base px-padding-md py-padding-md max-w-tab-width-normal mx-auto">
        <CommonLayout>
          <CommonSourceAccount
            type="source"
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            page="confirm"
          />

          <CommonDestinationAccount
            transactionPayload={txnPayLoad}
            setTransactionPayload={setTxnPayLoad}
            isReadOnly
            showsBalance={false}
          />

          <div className="w-width-full flex flex-col gap-gap-md">
            <Amount isPreview={true} txnPayLoad={txnPayLoad} />

            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={txnPayLoad?.settleType}
            />
          </div>
          <div className="w-width-full flex flex-col gap-gap-md">
            <NameFieldCard
              title={globalTextFormat(globalText?.SCHEDULE_NAME, [0, 1])}
              value={txnPayLoad?.scheduleName}
              previewMode={true}
            />

            <ConfidentialCard
              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={isConfidential}
              isPreview={true}
            />
          </div>
          <CategorySelector
            previewMode={true}
            selectedCategory={txnPayLoad?.selectedCategory}
            category={txnPayLoad?.mergeCategory || []}
            IFSC={txnPayLoad?.bankAccountIFSC}
            accountNumber={txnPayLoad?.bankAccountNo}
            beneAccountId={txnPayLoad?.beneAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />
          <TransactionOccurrenceDetails
            previewMode={true}
            txnPayLoad={txnPayLoad}
            formatDate={formateDate}
          />
          <AdditionalDetailsPreviewMapper
            mappingData={txnPayLoad.mergeCategory}
            previewImages={previewImages}
            uploadedFiles={uploadedFiles}
          />
          <AssignLabels
            previewMode={true}
            labels={allLabels}
            isOptional={true}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleTransactionStepConfirm;
